import { render } from "./Histogram.vue?vue&type=template&id=a21a034a&scoped=true"
import script from "./Histogram.vue?vue&type=script&lang=js"
export * from "./Histogram.vue?vue&type=script&lang=js"

import "./Histogram.vue?vue&type=style&index=0&id=a21a034a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21a034a"]])

export default __exports__